import React from "react";
import { IconProps } from "./IconProps";

const Minus: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 21 21"
            fill="none"
            {...props}
        >
            <path
                d="M4.19214 9.27393L15.8588 9.25147"
                stroke={color}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Minus;
